module.exports = __webpack_public_path__ + "img/GenderMan.03067e50.png";